
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("dPS3E"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("7deBc"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $cozmU.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $cozmU.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $8s9DV.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $kBr4q.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $kBr4q.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("dPS3E", function(module, exports) {

let $a129f88ad1bb7bc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a129f88ad1bb7bc0$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("7deBc", function(module, exports) {

let $5405125b8edc15fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5405125b8edc15fd$var$load("kT6dz"),
    $5405125b8edc15fd$var$load("csI9a"),
    $5405125b8edc15fd$var$load("cPAXo"),
    $5405125b8edc15fd$var$load("44j0l"),
    $5405125b8edc15fd$var$load("gbejv"),
    $5405125b8edc15fd$var$load("GD9EA"),
    $5405125b8edc15fd$var$load("7TnhR"),
    $5405125b8edc15fd$var$load("hUbK8"),
    $5405125b8edc15fd$var$load("eSqZD"),
    $5405125b8edc15fd$var$load("2PFjC"),
    $5405125b8edc15fd$var$load("7FwAE"),
    $5405125b8edc15fd$var$load("gGcQf"),
    $5405125b8edc15fd$var$load("fcAaN"),
    $5405125b8edc15fd$var$load("eyY0h"),
    $5405125b8edc15fd$var$load("5HweM"),
    $5405125b8edc15fd$var$load("l7djD"),
    $5405125b8edc15fd$var$load("by6h6"),
    $5405125b8edc15fd$var$load("j3345"),
    $5405125b8edc15fd$var$load("2J2X1"),
    $5405125b8edc15fd$var$load("do0Fh"),
    $5405125b8edc15fd$var$load("1Gr4q"),
    $5405125b8edc15fd$var$load("4RsKm"),
    $5405125b8edc15fd$var$load("7oAXW"),
    $5405125b8edc15fd$var$load("3RQq6"),
    $5405125b8edc15fd$var$load("7DmOr"),
    $5405125b8edc15fd$var$load("dxcsb"),
    $5405125b8edc15fd$var$load("9ZFGK"),
    $5405125b8edc15fd$var$load("2hLAI"),
    $5405125b8edc15fd$var$load("dCilB"),
    $5405125b8edc15fd$var$load("h1yOv"),
    $5405125b8edc15fd$var$load("1T8H1"),
    $5405125b8edc15fd$var$load("fyKFO"),
    $5405125b8edc15fd$var$load("d9sg7"),
    $5405125b8edc15fd$var$load("l0N35"),
    $5405125b8edc15fd$var$load("cmmpX"),
    $5405125b8edc15fd$var$load("fcsnw"),
    $5405125b8edc15fd$var$load("z9yIf"),
    $5405125b8edc15fd$var$load("FYSqe"),
    $5405125b8edc15fd$var$load("lLjjs"),
    $5405125b8edc15fd$var$load("cyTuQ"),
    $5405125b8edc15fd$var$load("jqoep"),
    $5405125b8edc15fd$var$load("6wr18"),
    $5405125b8edc15fd$var$load("59hV4"),
    $5405125b8edc15fd$var$load("8zMmc"),
    $5405125b8edc15fd$var$load("4x9Jx"),
    $5405125b8edc15fd$var$load("a8glC"),
    $5405125b8edc15fd$var$load("eCXJR"),
    $5405125b8edc15fd$var$load("1VTX2"),
    $5405125b8edc15fd$var$load("ffEVr"),
    $5405125b8edc15fd$var$load("gzrfp"),
    $5405125b8edc15fd$var$load("2EIkU"),
    $5405125b8edc15fd$var$load("ddvkk"),
    $5405125b8edc15fd$var$load("3upHR"),
    $5405125b8edc15fd$var$load("dBHUb"),
    $5405125b8edc15fd$var$load("5Rx9J"),
    $5405125b8edc15fd$var$load("Wowvf"),
    $5405125b8edc15fd$var$load("eRhBr"),
    $5405125b8edc15fd$var$load("hZ2FX"),
    $5405125b8edc15fd$var$load("hhss7"),
    $5405125b8edc15fd$var$load("7EorR"),
    $5405125b8edc15fd$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.0cee92b7.js.map
